/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        /* TO REMOVE
        $(window).on("scroll touchmove", function () {         
          $('body').toggleClass('stickymenu', $(document).scrollTop() > 50);            
        });
        */


        /* 
          SCROLL MORBIDO quando #
          

        */   
      
     
      
        /* END SCROLL MORBIDO quando # */




        $('.vc-hoverbox-front').matchHeight();


        /* 
          ALTEZZA UGUALE COLONNE IN VC 
          classe target:  ej-match-height-row

        */

        $('.ej-match-height-row').matchHeight({
            byRow: true,           
        });



        /* FINE */


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired


        /* SEARCH FABRICS POPUP */
        $('#search-fabrics-modal-select').select2({
           //placeholder :"Search",
           dropdownParent: $('#search-fabrics-modal')
          });
        $( "fieldset.fabrics-search-language input" ).checkboxradio({
            icon: false
          });
        $( "fieldset.fabrics-search-language" ).controlgroup({
          });   
 
        /* ABILITO LO SMOOTH SCROLL SU TUTTO IL SITO */

       /* $('a').smoothScroll();*/


        /* MENU STICKY */
        // non lo attivo in homepage

        $('.banner').stickUp({
            scrollHide:false,
            disableOn: function(){
              if( $('body').hasClass('home')){
                //console.log('home');
                return false;  
              }else{
                return true;
              }
            }
        }); 

        /* BACK TO TOP */

        $(window).on("scroll touchmove", function () {             

          if( $(document).scrollTop() > 100 ){

            $('#back-to-top').fadeIn();

          }else{
            $('#back-to-top').fadeOut();
          }      


        });

        $('#back-to-top').click(function(){
          $("html, body").animate({ scrollTop: 0 }, 600,'easeOutQuad');
        });




        /* go-to-link

        intercetto il link e lo mando alla pagina linkata
        usato per linkare aree grosse.
        
        */
        $('.ej-go-to-link').on('click', function(e){
          e.preventDefault();
          if($(this).data('ej-url')){
            window.location.href = $(this).data('ej-url');
          }
        });


        $('.ej-match-height-row-2').matchHeight({
            byRow: true,           
        });




    }
},
  // ----------------------------------------------- HOMEPAGE
  'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.fullscreen-bg__video').on('loadeddata',function(){
          //console.log('load');
          $('.focuspoint').adjustFocus();
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      setTimeout(function(){

        $('.focuspoint').focusPoint({
                reCalcOnWindowResize: true,
                throttleDuration: 10 //re-focus images at most once every 100ms.
            });

        },500);



/*
function SmoothScroll(target, speed, smooth) {
  if (target === document)
    target = (document.scrollingElement 
              || document.documentElement 
              || document.body.parentNode 
              || document.body) // cross browser support for document scrolling
      
  var moving = false
  var pos = target.scrollTop
  var frame = target === document.body 
              && document.documentElement 
              ? document.documentElement 
              : target // safari is the new IE
  
  target.addEventListener('mousewheel', scrolled, { passive: false })
  target.addEventListener('DOMMouseScroll', scrolled, { passive: false })

  function scrolled(e) {
    e.preventDefault(); // disable default scrolling

    var delta = normalizeWheelDelta(e)

    pos += -delta * speed
    pos = Math.max(0, Math.min(pos, target.scrollHeight - frame.clientHeight)) // limit scrolling

    if (!moving) update()
  }

  function normalizeWheelDelta(e){
    if(e.detail){
      if(e.wheelDelta)
        return e.wheelDelta/e.detail/40 * (e.detail>0 ? 1 : -1) // Opera
      else
        return -e.detail/3 // Firefox
    }else
      return e.wheelDelta/120; // IE,Safari,Chrome
  }

  function update() {
    moving = true;
    
    var delta = (pos - target.scrollTop) / smooth;
    
    target.scrollTop += delta;
    
    if (Math.abs(delta) > 0.5)
      requestFrame(update);
    else
      moving = false;
  }

  var requestFrame = function() { // requestAnimationFrame cross browser
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(func) {
        window.setTimeout(func, 1000 / 50);
      }
    );
  }();
}

new SmoothScroll(document,250,12);

*/


      /* CONTROLLO VISUALIZZAZIONE IMMAGINE EJ24 */
      function handlerIn(event){

        $('.hp_main_link').removeClass('active');
        $(event.target).addClass('active');


        $(".hp_images_item"+":not("+$(event.target).data('linkx')+")").removeClass('active');        

        setTimeout(function(){
          $("."+$(event.target).data('linkx')).addClass('active');
        },150);
       
       
      }

      function handlerOut(event){
        //$('.'+ $(event.target).data('linkx')).removeClass('active')
      }

      //$('.hp_main_link').on( "mouseenter", handlerIn ).on( "mouseleave", handlerOut );
      $('.hp_main_link').on( "mouseenter", handlerIn );


      setTimeout(function(){

        $('.hp_main_link_fabrics').trigger('mouseenter');

        },600);
      

      /* CARICO IMMAGINI INSTAGRAM */

      //var token = '5510995726.f66e8bb.bf9538c1ac91414ebfea59d9d0dbed81';
      //var token = 'IGQVJYUHBnVndTcXRpc1ZAzT05UMWlwWmN6N3A0WEkyREN0VGgyZAk9vODIzNnNFcE1PU2FCbkZAVUGtaMkVVdDdiYzU5dXR1NTkwZAlFCcU50OTF1U2k1OUlyRzdUd1RIVjViSEJaMGtR';

      // 16 03 23 cambio password e creazione nuovo token instagram
      //var token = 'IGQVJXUWd1NjhkQ240ZAmJqck9RS1pIbUdQWXhxYjM5SlNXU29YZAEIyY1NtVm96SkhSb2kxVTJhN29ock95c3dScTNrcW1RdmVUOWNoX0Nia1lsQ1JDZAHliVjBsQkVNaVBEY1hpc2dn';
      //var userid = 17841405391808874;

      //var token = 'IGQVJWZAVl5YmVhY2d2RUhFd2tFNS10ck04cUMyYk9YVWM0TS1rWUNuTjZA6MTU3LTktbnRzUUVoRl91X3FrN2d3eTgtQzhQVFBmRnhJMUp4cndENFlEUjBPRC1MUEJhcWV1TEt2NmRB';
      ///var token = 'IGQVJYeWdGRHVWUjBEc3poM01qYTdTMjJyS1BIZAUhwRDlmYUNUY1BZAT3Fxd0QxblJ5bDA0RUQ3TV85NDFXbW5reUJRWHhreXNiX1ZAXM21RRGxhYzhtd1ZAvMzRsdDFBNTlQcDNsQ2tB'; 
      ///var userid = 17841405391808874;

      var token = 'IGAA2al1I4UbZABZAE8xZAXJMb2xIWVozSGFoQUhYV0VNTWphZA1dacEZAWY0lUVzIwX0xxUE1jMDNldktaMjliQ2F0ZA3U4LXV6WGV5VVdmWG1aNzdsNXJIVzRmTXF4WFBmYXZApYkx0UGRHanZA0VlNoS21nZAzdn'; 
      var userid = 29296711389928180;

      var num_photos = 3; //7

          $.ajax({
              url: 'https://graph.instagram.com/' + userid + '/media', // or /users/self/media/recent for Sandbox
              dataType: 'jsonp',
              type: 'GET',
              data: {access_token: token, fields:"id,media_url,media_type,caption,thumbnail_url"},
              success: function(data){
                //console.log(data);
                counter = 0;
                
                for( var x in data.data ){
                  counter++;  
                  //console.log(data.data[x].media_url);

                  //console.log(data.data[x].images.standard_resolution.url);
                  //$('.ej-insta'+counter+' .instacover').css('background-image','url('+data.data[x].images.standard_resolution.url+')');
                  if(data.data[x].media_type === "VIDEO"){
                    $('.ej-insta'+counter+' .instacover').css('background-image','url('+data.data[x].thumbnail_url+')');

                  }else{
                    $('.ej-insta'+counter+' .instacover').css('background-image','url('+data.data[x].media_url+')');

                  }
                  
                  //$('.ej-insta'+counter).data('ej-url',data.data[x].link);
                  $('.ej-insta'+counter+' .instacover').data('ej-url','https://www.instagram.com/sensitivefabrics');

                  $('.ej-insta'+counter+' .instacover').on( 'click', function( e){
                    
                    e.preventDefault();                  
                    if(jQuery(this).data('ej-url')){
                    //  window.location.href = $(this).data('ej-url');
                     window.open(
                            jQuery(this).data('ej-url'),
                            
                            '_blank' // <- This is what makes it open in a new window.
                     );






                    }
                  }) ;                  

                  //$('ul#instagram').append('<li><img src="'+data.data[x].images.low_resolution.url+'"></li>'); // data.data[x].images.low_resolution.url - URL of image, 306х306
                  // data.data[x].images.thumbnail.url - URL of image 150х150
                  // data.data[x].images.standard_resolution.url - URL of image 612х612
                  // data.data[x].link - Instagram post URL 
                }
              },
              error: function(data){
                console.log("INSTAGRAM ERROR"); // send the error notifications to console
                console.log(data);
              }
            });
      /* FINE CARICO IMMAGINI INSTAGRAM */

      }
    },
    // ----------------------------------------------- PAGE THE 5 SENSE OF FABRIC

    'the_5_senses_of_the_fabric':{

      init: function() {
        
        // manufactoring and printing collapse
        $('.collapse').on('show.bs.collapse', function (event) {
          
          $('.collapse').each(function(){
           
            if ( $(this).attr('id') === event.target.id) {

              $("#"+$(event.target).data('background')).fadeIn();

            }else{
              $(this).collapse('hide');                
              $("#"+$(this).data('background')).fadeOut();
            }
          });
        });

        $('.collapse').on('hide.bs.collapse', function (event) {

          $("#"+$(event.target).data('background')).fadeOut();

        });
        
      },
      finalize: function() {





       /* MULTIPLE BOX */


       $('.ej-multiple-text:not(.active)').fadeOut(0);
       $('.ej-multiple-header').click(function(event){

         event.preventDefault();

         var index = $(this).index();
         var elemMax =  $('.ej-multiple-text').length;

         $('.ej-multiple-header').removeClass('active');
         $('.ej-multiple-header:eq('+index+')').addClass('active');

         var currentSrc = $('.ej-multiple-header:eq('+index+')').data('bck-src');
         var currentTarget = $('.ej-multiple-header:eq('+index+')').data('bck-target');      

         $(currentTarget).css('backgroundImage','url('+currentSrc+')');

         for(var i=0; i < elemMax; i++){
          if( index === i ){
            $('.ej-multiple-text').eq(i).fadeIn(500);
          }else{
            $('.ej-multiple-text').eq(i).fadeOut(0);
          }
        }       
      });

       /* fine multiple box */




      }//finalize 5 SENSES 
    },
  // ----------------------------------------------- ARCHIVE NEWS 
  'post_type_archive_ej_news':{
      finalize: function(){


        /* NASCONDERE LINK LATEST NEWS */
        // TODO        

        var waypoint = new Waypoint({
              element: document.getElementById('archive-news-read-more'),
              offset: 'bottom-in-view',
              handler: function(direction){                
                if( direction === 'down' ){
                  /* TODO x nascondere latest news*/
                }
              },
            }); 
        /* FINE NASCONDERE LINK LATEST NEWS */


        /* GESTISCO  TESTATA */ 
        function riempi_in_altezza(obj){
         
          var objTop = obj.offset().top;
          var viewportHeight = $(window).height();
          obj.css('min-height',viewportHeight-objTop);
          $('.archive-last-wrapper').css('min-height', obj.height()- 50);          
        }

         $(window).resize(function() {          
          riempi_in_altezza($('#archive-news-last'));
        });       

        setTimeout( function(){
          riempi_in_altezza($('#archive-news-last'));
          } ,300);
      }
     }, //post_type_archive_ej_news
// ----------------------------------------------- SINGLE NEWS 
   'single_ej_news':{
    finalize: function() {
      /*
        TOREMOVE 

        $(".ej-page-header-single-news").backstretch();
      
      */
     
     setTimeout(function(){

          $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            center: true,
            items:3,
            autoWidth:false,
            dots: false,
            navText: ['<i class="fa fa-chevron-left"></i>','<i class="fa fa-chevron-right"></i>'],
            responsiveClass: true,
            autoplay:true,
            autoplayTimeout:3000,
            autoplayHoverPause:true,
            autoplaySpeed:1200,
            fluidSpeed: true,
            responsive:{
              0:{
                items:1,
                autoWidth: false,
              },
              600:{
                items:3,
                autoWidth: true,

              }
            }
            });
      },500);

   }
 },
// ----------------------------------------------- PAGE SUSTAINABILITY
 'sustainability':{
  init: function() {  


    /* ANIMAZIONE ECONOMIC AND SOCIAL RESPONSABILITY */

    $('#slide_investments a').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideToggle('300',function(){
        $('html,body').animate(
        {
         scrollTop: ( $('#slide_investments_box').offset().top-50),
        },600);
      });
      $('#slide_tessere_box').slideUp('50');
      $('#slide_sclerosi_box').slideUp('50');   

    });  

    $('#slide_tessere a').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideUp('50');
      $('#slide_tessere_box').slideToggle('300',function(){
         $('html,body').animate(
         {
           scrollTop: ( $('#slide_tessere_box').offset().top-50),
         },600);
      });
      $('#slide_sclerosi_box').slideUp('50');

    }); 

    $('#slide_sclerosi a').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideUp('50');
      $('#slide_tessere_box').slideUp('50');
      $('#slide_sclerosi_box').slideToggle('300',function(){
       $('html,body').animate(
       {
         scrollTop: ( $('#slide_sclerosi_box').offset().top-50),
       },600);
      });
    });    

    $('.close_all_slide').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideUp('500');
      $('#slide_tessere_box').slideUp('500');
      $('#slide_sclerosi_box').slideUp('500');
    });   

    /* FINE ANIMAZIONE ECONOMIC AND SOCIAL RESPONSABILITY */


  },
  finalize: function() { 

    
      } 
    },
// ----------------------------------------------- PAGE SOSTENIBILITA
 'sostenibilita':{
  init: function() {  

  /* ANIMAZIONE ECONOMIC AND SOCIAL RESPONSABILITY */

    $('#slide_investments a').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideToggle('300',function(){
        $('html,body').animate(
        {
         scrollTop: ( $('#slide_investments_box').offset().top-50),
        },600);
      });
      $('#slide_tessere_box').slideUp('50');
      $('#slide_sclerosi_box').slideUp('50');   

    });  

    $('#slide_tessere a').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideUp('50');
      $('#slide_tessere_box').slideToggle('300',function(){
         $('html,body').animate(
         {
           scrollTop: ( $('#slide_tessere_box').offset().top-50),
         },600);
      });
      $('#slide_sclerosi_box').slideUp('50');

    }); 

    $('#slide_sclerosi a').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideUp('50');
      $('#slide_tessere_box').slideUp('50');
      $('#slide_sclerosi_box').slideToggle('300',function(){
       $('html,body').animate(
       {
         scrollTop: ( $('#slide_sclerosi_box').offset().top-50),
       },600);
      });
    });    

    $('.close_all_slide').click(function(event){
      event.preventDefault();
      $('#slide_investments_box').slideUp('500');
      $('#slide_tessere_box').slideUp('500');
      $('#slide_sclerosi_box').slideUp('500');
    });   

    /* FINE ANIMAZIONE ECONOMIC AND SOCIAL RESPONSABILITY */


  },
  finalize: function() { 

    
      } 
    },
// ----------------------------------------------- PAGE EPD 
    'epd':{
      init: function(){
         anime_epd = anime_epd_init();
      },
      finalize: function(){
         anime_epd.restart();

          /* MODAL PER EPD SVG */ 

      $('.epd_svg_elem_wrap_1').click(function(){
       $('#epd_modal_1').modal();
     });
      $('.epd_svg_elem_wrap_2').click(function(){
       $('#epd_modal_2').modal();
     });
      $('.epd_svg_elem_wrap_3').click(function(){
       $('#epd_modal_3').modal();
     });
      $('.epd_svg_elem_wrap_4').click(function(){
       $('#epd_modal_4').modal();
     });
      $('.epd_svg_elem_wrap_5').click(function(){
       $('#epd_modal_5').modal();
     });

      }
    },
// ----------------------------------------------- SINGLE FABRIC 
    'single_tessuto':{
      finalize: function() {

        /* TOOLTIP SUI LOGHI */
           $('[data-toggle="tooltip"]').tooltip({
            placement:'top',
            animation: true,
           } 
          /* END TOOLTIP SUI LOGHI */
          ); 

        function riempi_in_altezza(obj,gap){
         
          var objTop = obj.offset().top;
          var viewportHeight = $(window).height();        
          obj.height(viewportHeight -objTop -gap);      

        }

        $(window).resize(function() {

          riempi_in_altezza($('#single_fabric_image'),20);

        });       

        setTimeout( function(){

          riempi_in_altezza($('#single_fabric_image'),20);

        } ,300);

      }

    },


// ----------------------------------------------- PAGE 404
    'error404':{
      init: function() {

        function riempi_in_altezza(obj,gap){
         
          var objTop = obj.offset().top;
          var viewportHeight = $(window).height();        
          obj.height(viewportHeight -objTop -gap);      

        }

        $(window).resize(function() {

          riempi_in_altezza($('#page_404'),20);

        });       

        setTimeout( function(){

          riempi_in_altezza($('#page_404'),20);

        } ,300);

      }
    },

// ----------------------------------------------- PAGE 24WEAR 
    /*'24_wear':  modificato url della pagina 24-wear*/
    

    'solutions':{
      init: function() {

        orologio_svg = anime_orologio_init();

        
         // manufactoring and printing collapse
        $('.collapse').on('show.bs.collapse', function (event) {
          console.log('pippo');
          $('.collapse').each(function(){
            if ( $(this).attr('id') === event.target.id) {

              $("#"+$(event.target).data('background')).fadeIn();

            }else{
              $(this).collapse('hide');                
              $("#"+$(this).data('background')).fadeOut();
            }
          });
        });

        $('.collapse').on('hide.bs.collapse', function (event) {

          $("#"+$(event.target).data('background')).fadeOut();

        });



      },
      finalize:function(){


         
          orologio_svg.restart();
             /* ANIMAZIONE OROLOGIO - modal */


       $('.noninmovimento .orologio-elem-1').hover(
        function(){
     
          $(this).fadeTo(200,0.6);      

        },function(){
          $(this).fadeTo(200,1);         
        });

       $(' .orologio-elem-1').click(function(){
         $('#orologio_modal_extracomfort').modal();
       });

       $(' .orologio-elem-2').click(function(){
         $('#orologio_modal_bodymoisturesystem').modal();
       });

       
       $('.orologio-elem-3').click(function(){
         $('#orologio_modal_extrafine').modal();
       });
       
       $('.orologio-elem-4').click(function(){
         $('#orologio_modal_nopilling').modal();
       });

       $('.orologio-elem-5').click(function(){
         $('#orologio_modal_sunblock').modal();
       });

       $('.orologio-elem-6').click(function(){
         $('#orologio_modal_quickdrying').modal();
       });

       $('.orologio-elem-7').click(function(){
         $('#orologio_modal_chlorineresistance').modal();
       });

       $('.orologio-elem-8').click(function(){
         $('#orologio_modal_easycare').modal();
       });

       $('.orologio-elem-9').click(function(){
         $('#orologio_modal_wrinklefree').modal();
       });

       $('.orologio-elem-10').click(function(){
         $('#orologio_modal_noiron').modal();
       });  

         /* MULTIPLE BOX */


       $('.ej-multiple-text:not(.active)').fadeOut(0);
       $('.ej-multiple-header').click(function(event){


         event.preventDefault();

         var index = $(this).index();
         var elemMax =  $('.ej-multiple-text').length;

         $('.ej-multiple-header').removeClass('active');
         $('.ej-multiple-header:eq('+index+')').addClass('active');

         var currentSrc = $('.ej-multiple-header:eq('+index+')').data('bck-src');
         var currentTarget = $('.ej-multiple-header:eq('+index+')').data('bck-target');      

         $(currentTarget).css('backgroundImage','url('+currentSrc+')');

         for(var i=0; i < elemMax; i++){
          if( index === i ){
            $('.ej-multiple-text').eq(i).fadeIn(500);
          }else{
            $('.ej-multiple-text').eq(i).fadeOut(0);
          }
        }       
      });

       /* fine multiple box */


  

      }
    },
    // ----------------------------------------------- PAGE 24WEAR  - DUE
    
    'postid_6943':
 
    {
      init: function() {

        orologio_svg = anime_orologio_init();
      },
      finalize:function(){


         
          orologio_svg.restart();
             /* ANIMAZIONE OROLOGIO - modal */


       $('.noninmovimento .orologio-elem-1').hover(
        function(){
     
          $(this).fadeTo(200,0.6);      

        },function(){
          $(this).fadeTo(200,1);         
        });

       $(' .orologio-elem-1').click(function(){
         $('#orologio_modal_extracomfort').modal();
       });

       $(' .orologio-elem-2').click(function(){
         $('#orologio_modal_bodymoisturesystem').modal();
       });

       
       $('.orologio-elem-3').click(function(){
         $('#orologio_modal_extrafine').modal();
       });
       
       $('.orologio-elem-4').click(function(){
         $('#orologio_modal_nopilling').modal();
       });

       $('.orologio-elem-5').click(function(){
         $('#orologio_modal_sunblock').modal();
       });

       $('.orologio-elem-6').click(function(){
         $('#orologio_modal_quickdrying').modal();
       });

       $('.orologio-elem-7').click(function(){
         $('#orologio_modal_chlorineresistance').modal();
       });

       $('.orologio-elem-8').click(function(){
         $('#orologio_modal_easycare').modal();
       });

       $('.orologio-elem-9').click(function(){
         $('#orologio_modal_wrinklefree').modal();
       });

       $('.orologio-elem-10').click(function(){
         $('#orologio_modal_noiron').modal();
       });      
  

      }
    },
    // ----------------------------------------------- PAGE 24WEAR  TRE

    'postid_6941': 
    {
      init: function() {

        orologio_svg = anime_orologio_init();
      },
      finalize:function(){


         
          orologio_svg.restart();
             /* ANIMAZIONE OROLOGIO - modal */


       $('.noninmovimento .orologio-elem-1').hover(
        function(){
     
          $(this).fadeTo(200,0.6);      

        },function(){
          $(this).fadeTo(200,1);         
        });

       $(' .orologio-elem-1').click(function(){
         $('#orologio_modal_extracomfort').modal();
       });

       $(' .orologio-elem-2').click(function(){
         $('#orologio_modal_bodymoisturesystem').modal();
       });

       
       $('.orologio-elem-3').click(function(){
         $('#orologio_modal_extrafine').modal();
       });
       
       $('.orologio-elem-4').click(function(){
         $('#orologio_modal_nopilling').modal();
       });

       $('.orologio-elem-5').click(function(){
         $('#orologio_modal_sunblock').modal();
       });

       $('.orologio-elem-6').click(function(){
         $('#orologio_modal_quickdrying').modal();
       });

       $('.orologio-elem-7').click(function(){
         $('#orologio_modal_chlorineresistance').modal();
       });

       $('.orologio-elem-8').click(function(){
         $('#orologio_modal_easycare').modal();
       });

       $('.orologio-elem-9').click(function(){
         $('#orologio_modal_wrinklefree').modal();
       });

       $('.orologio-elem-10').click(function(){
         $('#orologio_modal_noiron').modal();
       });      
  

      }
    },
    'post_type_archive_ej_press':{
      init: function(){
          function riempi_in_altezza(obj,gap){
         
            var objTop = obj.offset().top;
            var viewportHeight = $(window).height();        
            obj.height(viewportHeight -objTop -gap);      
        }

        $(window).resize(function() {

          riempi_in_altezza($('#press-cover-image'),20);

        });       

        setTimeout( function(){

          riempi_in_altezza($('#press-cover-image'),20);

        } ,300);
      }

    },

    'post_type_archive_tessuto': {
      init: function() {

        /*function riempi_in_altezza(obj,gap){
            var objTop = obj.offset().top;
            var viewportHeight = $(window).height();        
            obj.height(viewportHeight -objTop -gap);      
        }

        $(window).resize(function() {
          //riempi_in_altezza($('#tessuto-cover-image'),20);
        }); 

        setTimeout( function(){
          //riempi_in_altezza($('#tessuto-cover-image'),20);
        } ,60);
        */
      
       },
       finalize: function() {

        texileInit();

       }
     },
     'company':{
      init: function() {
       
        
       
      },
      finalize: function() {


        function resizeVideoCompany(){

        //elem =   $('#video_company video ');
        elem =   $('#video_company ');
        

        if(elem.length > 0) {

        offset_top = elem.parent().offset().top;
         viewport_h = $(window).height();
         video_w = elem.parent().width();
         video_h = (video_w / 1.7777777777777);
         if(video_h > (viewport_h - offset_top -15)){
     
         elem.css('max-width','100%');
          elem.css('max-height',(viewport_h - offset_top -15));
       
         }else{ 
                 
           elem.css('max-width','100%');
           elem.css('max-height', 'auto');
         }
       }

        }

        elem =   $('#video_company ');

        elem.on('loadeddata',function(){
              resizeVideoCompany();            
             elem.get(0).play();
        });

        var vid = document.getElementById("video_company");       

              vid.oncanplay = function() {
                resizeVideoCompany();
                 $('#video_company ').get(0).play();

              }; 

        resizeVideoCompany();


       $(window).resize(function() {
 
         resizeVideoCompany();
        });
     }


     },
     'azienda':{
      init: function() {
       
        
       
      },
      finalize: function() {


        function resizeVideoCompany(){

         offset_top = $('#video_company').parent().offset().top;
         viewport_h = $(window).height();
         video_w = $('#video_company').parent().width();
         video_h = (video_w / 1.7777777777777);
         if(video_h > (viewport_h - offset_top -15)){
     
          $('#video_company').css('max-width','100%');
          $('#video_company').css('max-height',(viewport_h - offset_top -15));
       
         }else{ 
                 
           $('#video_company').css('max-width','100%');
           $('#video_company').css('max-height', 'auto');
         }

        }

         $('#video_company').on('loadeddata',function(){
            resizeVideoCompany();
            $('#video_company').get(0).play();

        });
         var vid = document.getElementById("video_company");
              vid.oncanplay = function() {
                resizeVideoCompany();
                 $('#video_company').get(0).play();
              }; 

        resizeVideoCompany();

       $(window).resize(function() {
         resizeVideoCompany();
        });
     }


     }, //fine azienda
     'post_type_archive_ej_video':{
      finalize: function(){


        $('.video_ej_modal').on('hide.bs.modal',function(e){

          var video =  $(e.target).find('.embed-responsive-item').get(0);         
           $(video).attr("src", $(video).attr("src"));

        });


        function riempi_in_altezza(obj){
         
          var objTop = obj.offset().top;
          var viewportHeight = $(window).height();
          //obj.height(viewportHeight-objTop);
          $('.archive-last-wrapper').css('min-height', obj.height() -50);
          obj.css('min-height',viewportHeight-objTop);

        }

        $(window).resize(function() {
          riempi_in_altezza($('#archive-video-last'));
        });

        riempi_in_altezza($('#archive-video-last'));

        setTimeout( function(){
          riempi_in_altezza($('#archive-video-last'));
          } ,300);




        
      }
     }, //post_type_archive_ej_video
     'post_type_archive_ej_brands':{

      finalize: function(){

        


      /*  $('.video_ej_modal').on('hide.bs.modal',function(e){

          var video =  $(e.target).find('.embed-responsive-item').get(0);         
           $(video).attr("src", $(video).attr("src"));

        });*/


        function riempi_in_altezza(obj){
         
          var objTop = obj.offset().top;
          var viewportHeight = $(window).height();
          //obj.height(viewportHeight-objTop);
          $('.archive-last-wrapper').css('min-height', obj.height() -50);
          obj.css('min-height',viewportHeight-objTop);

        }

        $(window).resize(function() {
          riempi_in_altezza($('#archive-brand-last'));
        });

        riempi_in_altezza($('#archive-brand-last'));

        setTimeout( function(){
          riempi_in_altezza($('#archive-brand-last'));
          } ,300);






        
      }
     }, //post_type_archive_ej_brands

      'single_ej_brands':{

      finalize: function(){ 



        setTimeout(function(){
          $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            center: true,
            items:3,
            autoWidth:false,
            dots: false,
            navText: ['<i class="fa fa-chevron-left"></i>','<i class="fa fa-chevron-right"></i>'],
            responsiveClass: true,
            responsive:{
              0:{
                items:1,
                autoWidth: false,
              },
              600:{
                items:3,
                autoWidth: true,

              }
            }
          });
        },500);
      }

     },
     'page':{
      finalize: function(){ 
        setTimeout(function(){
         $('#lm-tooltip').tooltip({
            placement:'top',
            animation: true,
            html: true
           });
         
        },600);
        }
        
      },
      'cookie_policy':{
        init: function(){ 

            /*
              console.log(window.location.pathname);
              var ref = document.scripts[0],
              elem = document.createElement("script");
              elem.id = "Cookiebot";
              elem.src = "https://consent.cookiebot.com/uc.js";
              elem.dataset.cbid = "84e64647-3826-4f06-af0f-a66872510781";
              elem.dataset.blockingmode = "auto";   //
              elem.dataset.widgetEnabled = "false"; //bingo
              elem.async = false;
              ref.parentNode.insertBefore(elem, ref);
              console.log("Script is sett");
              */
           
 
         


   


        } // end finalize
      }

     


    

   };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


